// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__dL5u_","inner":"Footer_inner__2ailA"};